import React, { lazy } from 'react'
import settingsRoutes from './Settings/SettingsRoutes'

const BankEFTListing = lazy(() =>
  import('./BankEFTListing').then(module => ({
    default: module.BankEFTListing,
  }))
)
const SettingsSubmenu = lazy(() =>
  import('./Settings/SettingsSubmenu').then(module => ({
    default: module.SettingsSubmenu,
  }))
)

export const bankEFTRoutes = [
  {
    props: {
      exact: true,
      path: '/bank-eft',
    },
    component: <BankEFTListing />,
  },
  {
    props: {
      exact: true,
      path: '/bank-eft/:BankEFTID',
    },
    component: <SettingsSubmenu />,
  },
  ...settingsRoutes,
]

export default bankEFTRoutes
